module.exports = __webpack_public_path__ + "static/media/horse-head.b474f61b.svg";